export const pageBgColor = 'rgb(244, 246, 248)';
export const tabBackgroundColor = '#A9BED9';
export const tableBorderColor = '#e0e0e0';
export const borderColor = '#e0e0e0';
export const borderRadius = '2px';
export const buttonBorderColor = '#e0e0e0';
export const disabledColor = 'rgba(0, 0, 0, 0.3)';
export const primary1Color = ' #596d85';
export const primaryTextColor = '#263238';
export const secondaryTextColor = 'rgba(0, 0, 0, 0.54)';
export const okColor = '#8bc34a';
export const fontFamily = 'Roboto, sans-serif';

// tslint:disable: object-literal-sort-keys
export const zIndexes = {
    notificationsLayer: 1450,
    defaultDialog: 1500,
    orbitFab: 1590,
    emailComposeLayer: 1600,
    overEmailDialog: 1700,
    timePickerDialog: 1750,
    timePickerDropdown: 1800, // cspell:ignore dropdown
    orbitOverlay: 1820,
    orbitTooltip: 1825,
    audioPlayer: 1830,
    modalDialog: 1900,
    snackBar: 2000
};
